var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTickIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6404 16.8746L18.3744 9.14056L16.4064 7.1717L10.6404 12.8906L7.64044 9.84341L5.62444 11.8586L10.6404 16.8746ZM20.484 20.484C18.1406 22.8274 15.312 24 12 24C8.68714 24 5.85943 22.8274 3.51514 20.484C1.17171 18.1406 0 15.3129 0 12C0 8.68714 1.17171 5.85857 3.51514 3.51514C5.85943 1.17171 8.68714 0 12 0C15.312 0 18.1406 1.17171 20.484 3.51514C22.8283 5.85857 24 8.68714 24 12C24 15.3129 22.8283 18.1406 20.484 20.484Z",
  fill: "#4585FF"
})));
export default SvgTickIcon;